const ERR_BRAND = {
    isError: true,
    errorMessage: "Select Brand"
};

const ERR_MODEL = {
    isError: true,
    errorMessage: "Select Model"
};

const ERR_YEAR = {
    isError: true,
    errorMessage: "Select Year"
};

const ERR_VARIANT = {
    isError: true,
    errorMessage: "Select Variant"
};

const ERR_STATE = {
    isError: true,
    errorMessage: "Select State"
};

export const ERR_MOBILE = {
    isError: true,
    errorMessage: "Mobile Number is required"
};

export const ERR_TYPES = {
    BRAND: "brand",
    MODEL: "model",
    YEAR: "year",
    VARIANT: "variant",
    STATE: "state",
    MOBILE: "mobile"
};

export const getErrorWithType = ({ type, extras = {} }) => {
    const errMap = {
        [ERR_TYPES.BRAND]: ERR_BRAND,
        [ERR_TYPES.MODEL]: ERR_MODEL,
        [ERR_TYPES.YEAR]: ERR_YEAR,
        [ERR_TYPES.VARIANT]: ERR_VARIANT,
        [ERR_TYPES.STATE]: ERR_STATE,
        [ERR_TYPES.MOBILE]: ERR_MOBILE
    };
    return {
        [type]: {
            ...errMap[type],
            ...extras
        }
    };
};

export const unsetErrorType = ({ error, type }) => {
    const err = { ...error };
    delete err[type];
    return err;
};
